var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(34,158,69)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.168 68.369 l 35.957 -23.337 l -36.175 -23.4 L 8.875 45.088 L 45.168 68.369 L 45.168 68.369 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,229,9)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.835 45.001 c 0 8.388 -6.81 15.187 -15.212 15.187 c -8.401 0 -15.212 -6.8 -15.212 -15.187 s 6.811 -15.187 15.212 -15.187 C 54.025 29.813 60.835 36.613 60.835 45.001 L 60.835 45.001 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,73,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.623 54.097 l -0.47 -0.271 l -0.488 0.242 l 0.109 -0.543 l -0.377 -0.397 l 0.539 -0.063 l 0.253 -0.487 l 0.226 0.503 l 0.532 0.097 l -0.399 0.373 M 50.817 56.678 l -0.47 -0.271 l -0.488 0.242 l 0.109 -0.543 l -0.377 -0.397 l 0.539 -0.063 l 0.253 -0.487 l 0.226 0.503 l 0.532 0.097 l -0.399 0.373 M 46.423 52.555 l -0.406 -0.234 l -0.422 0.208 l 0.094 -0.469 l -0.326 -0.343 l 0.466 -0.055 l 0.219 -0.42 l 0.195 0.435 l 0.46 0.083 l -0.345 0.323 M 56.718 51.072 l -0.399 -0.23 l -0.414 0.205 l 0.093 -0.46 l -0.32 -0.337 l 0.457 -0.054 l 0.215 -0.413 l 0.192 0.427 l 0.451 0.082 l -0.338 0.317 M 46.237 47.985 l -0.47 -0.271 l -0.488 0.242 l 0.109 -0.543 l -0.377 -0.397 l 0.539 -0.063 l 0.253 -0.487 l 0.226 0.503 l 0.532 0.097 l -0.399 0.373 M 33.685 43.273 l -0.47 -0.271 l -0.488 0.242 l 0.109 -0.542 l -0.377 -0.398 l 0.539 -0.063 l 0.253 -0.487 l 0.226 0.503 l 0.532 0.097 l -0.399 0.373 M 35.195 49.542 l -0.47 -0.271 l -0.488 0.242 l 0.109 -0.542 l -0.377 -0.398 l 0.539 -0.063 l 0.253 -0.487 l 0.226 0.503 l 0.532 0.097 l -0.399 0.374 M 50.858 39.965 l -0.415 -0.239 l -0.431 0.213 l 0.097 -0.479 l -0.333 -0.351 l 0.476 -0.056 l 0.224 -0.43 l 0.2 0.445 l 0.47 0.085 l -0.352 0.33",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,239)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.623 46.502 l -0.47 -0.271 l -0.488 0.242 l 0.109 -0.542 l -0.377 -0.398 l 0.539 -0.063 l 0.253 -0.487 l 0.226 0.503 l 0.532 0.097 l -0.399 0.374",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,239)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.833 50.464 c 0.232 -0.606 0.531 -1.521 0.69 -2.36 c -8.079 -7.097 -17.086 -10.733 -28.467 -9.985 c -0.408 0.782 -0.735 1.601 -1.01 2.487 C 44.531 39.32 54.415 45.29 59.833 50.464 L 59.833 50.464 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrFlag);
export default __webpack_public_path__ + "static/media/br-flag.1a3ecf55cccdb4c1be267fe50e647790.svg";
export { ForwardRef as ReactComponent };